import { FCX, Portal, Tooltip, useUuid } from "@datassential/platform-ui-lib";
import { ReactNode, isValidElement, cloneElement, useMemo, ReactElement, ComponentProps } from "react";

const DATA_ATTR = "data-tooltip-id";

const TooltipWrapper: FCX<{
    thumbnail: ReactNode;
    tooltipProps?: Omit<ComponentProps<typeof Tooltip>, 'id'>;
}> = ({
    thumbnail,
    tooltipProps,
    children,
}) => {
    const tooltipId = useUuid();

    const tooltip = useMemo(
        () => (
            <Portal>
                <Tooltip
                    {...tooltipProps}
                    id={tooltipId}
                >
                    {children}
                </Tooltip>
            </Portal>
        ),
        [children, tooltipId, tooltipProps]
    );

    if (!children) {
        return <>{thumbnail}</>;
    }

    if (isValidElement(thumbnail)) {
        return (
            <>
                {cloneElement(thumbnail as ReactElement, { [DATA_ATTR]: tooltipId })}
                {tooltip}
            </>
        );
    }

    return (
        <>
            <span data-tooltip-id={tooltipId}>{thumbnail}</span>
            {tooltip}
        </>
    );
};

export default TooltipWrapper;